import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import { fetchActiveEmployees, fetchCategory, fetchDepartment, fetchDesignation, getloanapprovaldetails, SaveLoanApprovals } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { FaCheck } from "react-icons/fa";

const PayrollLoanApproval = () => {
  const location = useLocation();
  const history = useHistory();

  const [accessRight, setAccessRight] = useState(null);

  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location, history]);

  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [employeeDataSelected, setEmployeeDataSelected] = useState(null);
  const [data, setData] = useState([]);
  const [loanApprovalData, setloanApprovalData] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);

  const { canRead, canCreate, canEdit, canDelete, canApprove } =
    useButtonAccess(accessRight);

  const {
    employees,
    categoryList,
    departmentList,
    designationList,
    employeeloanapplists,
    loading,
    success,
    error,
    saveSuccess,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    departmentList: state.EmployeeDetailsReducer?.departmentList ?? [],
    designationList: state.EmployeeDetailsReducer?.designationList ?? [],
    categoryList: state.EmployeeDetailsReducer?.categoryList ?? [],
    employeeloanapplists: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeeloanapplists ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    error: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
    saveSuccess: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.saveSuccess,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    const user = authUserDetails[0];
    setAuthDetails(user);
    dispatch(fetchActiveEmployees(user.unit_id));
    dispatch(fetchCategory(user.unit_id));
    dispatch(fetchDepartment(user.unit_id));
    dispatch(fetchDesignation(user.unit_id));
  }, [dispatch]);


  let categoryOptions = [], deptOptions = [], desigOption = [];

  categoryOptions = (categoryList || []).map(item => ({ label: item.empCategory, value: item.empCatgryid }));
  deptOptions = (departmentList || []).map(item => ({ label: item.departmentcode, value: item.departmentId }));
  desigOption = (designationList || []).map(item => ({ label: item.designation, value: item.desig_id }));

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category: null,
      department: null,
      designation: null,
      employee: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      const formData = new FormData();
      const selecteddata = (loanApprovalData || []).map(row => ({
        loan_freeze_id: row.loan_freeze_id,
        loan_id: row.loan_id,
        emp_id: row.emp_id,
        loan_type_id: row.loan_type_id,
      }));
      if (selecteddata.length === 0) {
        Swal.fire({ icon: "warning", title: "No Selection", text: "Please select at least one before proceeding.", });
        return;
      }
      let result = { appls: selecteddata };
      formData.append("lst_employee_loanapprovals", JSON.stringify(result));
      formData.append("create_by", authDetails?.user_id);
      dispatch(SaveLoanApprovals(formData))
    },
  });

  const fetchLoanData = (filters = {}) => {
    const formData = new FormData();

    formData.append("cat_id", filters.category || 0);
    formData.append("dept_id", filters.department || 0);
    formData.append("desig_id", filters.designation || 0);
    formData.append("emp_id", filters.employee || 0);
    formData.append("unit_id", authDetails?.unit_id);

    dispatch(getloanapprovaldetails(formData));
  };

  useEffect(() => {
    if (authDetails?.unit_id) {
      fetchLoanData();
    }
  }, [authDetails]);

  useEffect(() => {
    setData(Array.isArray(employeeloanapplists) ? employeeloanapplists : []);
  }, [employeeloanapplists]);

  const handleSearch = () => {
    fetchLoanData({
      category: formik.values.category,
      department: formik.values.department,
      designation: formik.values.designation,
      employee: formik.values.employee?.value,
    });
  };

  const resetFormData = () => {
    formik.resetForm();
    setEmployeeDataSelected(null);
    fetchLoanData();
  };

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => data.length - row.index,
    },
    { Header: "CODE", accessor: "emp_no" },
    { Header: "NAME", accessor: "emp_name" },
    { Header: "LOAN TYPE", accessor: "loan_type" },
    { Header: "PRINCIPAL AMOUNT", accessor: "principal_amount" },
    { Header: "LOAN AMOUNT", accessor: "total_amount" },
    { Header: "INSTALLMENTST", accessor: "total_installments" },
    { Header: "START DATE", accessor: "start_date" },
    { Header: "END DATE", accessor: "end_date" },
    { Header: "CREATED BY", accessor: "create_by" },
    { Header: "CREATED DATE", accessor: "create_dt" },
    { Header: "LOAN STATUS", accessor: "loan_status" },
    {
      id: "selection",
      className: "serial-no text-center",
      Header: ({ getToggleAllPageRowsSelectedProps }) => (
        <input
          type="checkbox"
          {...getToggleAllPageRowsSelectedProps()}
        />
      ),
      Cell: ({ row }) => (
        <input
          type="checkbox"
          {...row.getToggleRowSelectedProps()}
        />
      ),
    },
    // { Header: "APPROVE", accessor: "approve", Cell: ({ value }) => <input type="checkbox" checked={value} readOnly /> },
  ];

  const handleSelectedRowsChange = React.useCallback((rows) => { setloanApprovalData(rows); }, []);

  useEffect(() => {
    if (saveSuccess) {
      dispatch({ type: "RESET_SAVE_STATUS" });
      resetFormData();
    }
  }, [saveSuccess, dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Payroll / Employee Loan" breadcrumbItem="Loan Approval" />
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  {/* Employee */}
                  <Col md={4}>
                    <FormGroup>
                      <Label>Employee</Label>
                      <CustomSelect
                        id="employee"
                        name="employee"
                        isMulti={false}
                        options={employees}
                        value={employeeDataSelected}
                        onChange={(selectedOption) => {
                          setEmployeeDataSelected(selectedOption);
                          formik.setFieldValue("employee", selectedOption);
                        }}
                        onBlur={() => formik.setFieldTouched("employee", true)}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable={true}
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={8} className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="button" className="btn button-search me-2" onClick={handleSearch}> <i className="fas fa-search me-1" /> Search</Button>
                    {data && data.length > 0 && (
                      <Dropdown className="mb-3" isOpen={dropdownOpen} toggle={toggle} direction="down">
                        <DropdownToggle color="primary" className="btn button-export mt-3 me-2">
                          <i className="fas fa-file-export me-1" /> Export
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => exportEmployeeToExcel(data, authDetails?.unit_fullname, authDetails?.unit_address, "Employee Increment Report")}>
                            <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                          </DropdownItem>
                          <DropdownItem onClick={() => exportEmployeeToPDF(data, authDetails?.unit_fullname, authDetails?.unit_address, "Employee Increment Report", columns)}>
                            <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    )}
                    <Button type="submit" className="btn button-save me-2"> <i className="fas fa-check-circle me-1" /> Approve</Button>
                    <Button type="reset" className="btn button-cancel"
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                          showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                        }).then((result) => {
                          if (result.isConfirmed) {
                            resetFormData();
                          }
                        });
                      }}
                    >
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer columns={columns} data={data && data?.length > 0 ? data : []} isGlobalFilter={true} customPageSize={10} onSelectedRowsChange={handleSelectedRowsChange} />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PayrollLoanApproval;
